import { makeAutoObservable } from 'mobx'

/**
 * Шухляда «Обране».
 *
 * Самі записи тут не живуть: їх тримає `Ship/Stores/FavoritesManager`, бо той
 * самий список читає зірочка в шапці кожної картки.
 */
class FavoritesDrawerStoreClass {
    isOpen = false

    constructor() {
        makeAutoObservable(this)
    }

    setIsOpen(value: boolean): void {
        this.isOpen = value
    }
}

export const FavoritesDrawerStore = new FavoritesDrawerStoreClass()
